<template>
  <div>
    <br />
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <p class="title is-2 has-text-weight-bold">
            <b-icon icon="sale" size="is-medium" type="is-primary"> </b-icon>
            Reporte Venta productos
          </p>
        </div>
      </div>
    </nav>
    <div class="columns">
      <!-- Selección de tipo -->
      <div class="column">
        <b-field label="Tipo">
          <b-select v-model="tipo" @change.native="obtenerHistorialConFecha">
            <option value="">Sin seleccionar</option>
            <!-- Opción para mostrar todos -->
            <option value="venta">Venta</option>
            <option value="cuenta">Credito/Cuenta</option>
          </b-select>
        </b-field>
      </div>

      <!-- Selección de categoría -->
      <div class="column">
        <b-field label="Categoría">
          <b-select
            v-model="idCategoria"
            @change.native="obtenerHistorialConFecha"
          >
            <option value="">Sin seleccionar</option>
            <!-- Opción para mostrar todos -->
            <option
              v-for="categoria in categorias"
              :key="categoria.id"
              :value="categoria.id"
            >
              {{ categoria.nombreCategoria }}
            </option>
          </b-select>
        </b-field>
      </div>

      <busqueda-en-fecha @seleccionada="onBusquedaEnFecha" />
    </div>
    <div class="field is-grouped">
      <p class="control">
        <b-select v-model="perPage">
          <option value="10">10 por página</option>
          <option value="20">20 por página</option>
          <option value="30">30 por página</option>
          <option value="50">50 por página</option>
          <option value="100">100 por página</option>
        </b-select>
      </p>
      <p class="control">
        <span class="total-amount"
          >Total: $ {{ parseInt(total).toLocaleString("es-CO") }}</span
        >
      </p>

      <p class="control">
        <span class="total-amount"
          >Total Productos: {{ parseInt(total2) }}</span
        >
      </p>
    </div>

    <b-table
      :data="historial"
      :paginated="isPaginated"
      :per-page="perPage"
      :bordered="true"
      :striped="true"
      :current-page.sync="currentPage"
      :pagination-simple="isPaginationSimple"
      :pagination-position="paginationPosition"
      :default-sort-direction="defaultSortDirection"
      :pagination-rounded="isPaginationRounded"
      :sort-icon="sortIcon"
      :sort-icon-size="sortIconSize"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
    >
      <b-table-column
        field="nombreProducto"
        label="Producto"
        searchable
        sortable
        v-slot="props"
      >
        {{ props.row.nombreProducto }}
      </b-table-column>

      <b-table-column
        field="cantidadVendida"
        label="Cantidad Vendida"
        sortable
        v-slot="props"
      >
        {{ props.row.cantidadVendida }}
      </b-table-column>

      <b-table-column field="valorTotal" label="Total" sortable v-slot="props">
        ${{ parseInt(props.row.valorTotal).toLocaleString("es-CO") }}
      </b-table-column>
    </b-table>
  </div>
</template>
          <script>
import HttpService from "../../Servicios/HttpService";
import BusquedaEnFecha from "../Extras/BusquedaEnFecha";

export default {
  components: {
    BusquedaEnFecha,
  },

  data: () => ({
    filtros: {
      fechaInicio: "",
      fechaFin: "",
    },
    historial: [],
    cargando: false,
    isPaginated: true,
    isPaginationSimple: false,
    isPaginationRounded: true,
    paginationPosition: "bottom",
    defaultSortDirection: "asc",
    sortIcon: "arrow-up",
    sortIconSize: "is-small",
    currentPage: 1,
    perPage: 30,
    tipo: "",
    categorias: {},
    idCategoria: "",
    total: 0,
    total2: 0,
  }),

  mounted() {
    this.obtenerHistorialConFecha();
    document.title = "Ventas por productos";
    this.obtenerCategorias();
  },

  methods: {
    obtenerCategorias() {
      HttpService.obtenerConConsultas("categorias.php", {
        accion: "obtener",
      }).then((resultado) => {
        // Ordenar las categorías alfabéticamente
        this.categorias = resultado.sort((a, b) => {
          // Asume que las categorías tienen una propiedad "nombre"
          return a.nombreCategoria.localeCompare(b.nombreCategoria);
        });
      });
    },
    onBusquedaEnFecha(fechas) {
      // Establecer la fecha de inicio con la hora constante a las 05:00:00 en UTC
      const fechaInicio = new Date(fechas[0]);
      fechaInicio.setUTCHours(5, 0, 0, 0); // Establecer la hora a las 05:00:00 en UTC
      // Formatear la fecha y hora como cadena "YYYY-MM-DD HH:mm:ss"
      const fechaInicioString =
        fechaInicio.toISOString().split("T")[0] + " 05:00:00";
      this.filtros.fechaInicio = fechaInicioString;
      // Establecer la fecha de fin con la hora constante a las 05:00:00 en UTC
      const fechaFin = new Date(fechas[1]);
      fechaFin.setUTCHours(5, 0, 0, 0); // Establecer la hora a las 05:00:00 en UTC
      // Sumar un día a la fecha fin
      fechaFin.setUTCDate(fechaFin.getUTCDate() + 1);
      // Formatear la fecha y hora como cadena "YYYY-MM-DD HH:mm:ss"
      const fechaFinString = fechaFin.toISOString().split("T")[0] + " 05:00:00";
      this.filtros.fechaFin = fechaFinString;
      this.obtenerHistorialConFecha();
    },
    obtenerHistorialConFecha() {
      let payload = {
        accion: "obtenerHistorialConFecha",
        tipo: this.tipo,
        idCategoria: this.idCategoria,
        filtros: this.filtros,
      };

      HttpService.obtenerConConsultas("productos.php", payload).then(
        (resultado) => {
          this.historial = resultado;

          // Calcula el total sumando todos los valores 'total' de cada item en el historial
          this.total = this.historial.reduce((acumulador, item) => {
            // Asegúrate de convertir item.total a un número
            return acumulador + parseFloat(item.valorTotal);
          }, 0);
          this.total2 = this.historial.reduce((acumulador, item) => {
            const cantidad = parseInt(item.cantidadVendida, 10);
            return acumulador + (cantidad > 0 ? cantidad : 0);
          }, 0);
        }
      );
    },
  },
};
</script>
  <style scoped>
.total-amount {
  color: green; /* Estilo para mostrar el total en verde */
  font-weight: bold; /* Opcional: resalta el texto */
  margin-left: 20px; /* Opcional: añade espacio a la izquierda del  */
}
</style>